import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class StoreReturnRequest {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    storeReturnId: number;
}